export default __webpack_public_path__ + "static/media/banner (2).68f803cb.jpg";